import { IncentivesPermissionType } from '../incentivesPermissionType';
export const incentivesRoleSchema = {
    $id: 'urn:wisepipe-domain-authorize:IncentivesRole',
    type: 'object',
    properties: {
        orgID: { type: 'string', format: 'uuid' },
        roleID: { type: 'string', format: 'uuid' },
        users: { type: 'array', items: { type: 'string', format: 'uuid' } },
        permissions: {
            type: 'object',
            additionalProperties: { type: 'array', items: { type: 'string', enum: Object.values(IncentivesPermissionType) } }
        }
    },
    required: ['orgID', 'roleID', 'users', 'permissions']
};
//# sourceMappingURL=incentivesRole.js.map